import { useEffect, useRef } from "react";

import { trackPageView } from "@/lib/analytics";

/**
 * URL 변경을 감지하여 페이지뷰 이벤트를 자동 전송하는 훅.
 *
 * flemo 라우터는 내부적으로 `history.pushState` / `replaceState`를 사용하므로,
 * 해당 API를 패치해 URL 변경 시점을 캡처한다.
 */
export function usePageViewTracker() {
  const prevPathRef = useRef(window.location.pathname);

  useEffect(() => {
    function handlePathChange() {
      const currentPath = window.location.pathname;

      if (currentPath !== prevPathRef.current) {
        prevPathRef.current = currentPath;
        trackPageView(currentPath);
      }
    }

    // 초기 페이지뷰
    trackPageView(window.location.pathname);

    // popstate (뒤로가기/앞으로가기)
    window.addEventListener("popstate", handlePathChange);

    // pushState / replaceState 패치
    const originalPush = history.pushState.bind(history);
    const originalReplace = history.replaceState.bind(history);

    history.pushState = (...args) => {
      originalPush(...args);
      handlePathChange();
    };

    history.replaceState = (...args) => {
      originalReplace(...args);
      handlePathChange();
    };

    return () => {
      window.removeEventListener("popstate", handlePathChange);
      history.pushState = originalPush;
      history.replaceState = originalReplace;
    };
  }, []);
}
